import { respondTo } from '@legacy-vfuk/core-mixins';
import styled, { css } from 'styled-components';

export const MainLinksWrapper = styled.div`
  padding: 0 1rem;

  > div {
    max-width: 1240px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 116px 1fr;
    align-items: center;

    nav {
      display: flex;
      justify-content: space-between;
      ul {
        display: none;
        @media (min-width: 1025px) {
          display: flex;
          gap: 2rem;
        }
        
        flex: 1;
        font-size: 1.25rem;
        line-height: 1.75rem;

        &.main-nav-items {
          justify-content: flex-start;
        }

        &.sign-in-items {
          justify-content: flex-end;

          [class*='LinkWithIconstyle__LinkWithIcon-sc'] {
            gap: 0.5rem;

            [class*='LinkWithIconstyle__IconContainer-sc'] {
              margin: 0;
            }
          }
        }

        li {
          padding: 1.375rem 0;
        }
      }
    }
  }
`;

export const BrandLogo = styled.a`
  display: flex;
  gap: 1rem;

  padding: 1.25rem 0;

  ${respondTo.lg(
    css`
      padding: 0;
    `
  )}

  svg {
    width: 24px;
    height: 24px;

    @media (min-width: 768px) {
      width: 36px;
      height: 36px;
    }
  }
`;
